import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Table from 'react-bootstrap/Table'
import FlightNumbers from './FlightNumbers'
import { discTypeName } from './discModel'

const loadBrands = () => ({
  type: 'LOAD_BRANDS',
  payload: {
    request: {
      url: `/v3/disc/brands`,
    },
  },
})

function BrandDetails({ brands, loading, loaded }) {
  const dispatch = useDispatch()
  const { brandKey } = useParams()

  // Support deep-linking straight to a brand: load the catalog if it isn't here yet.
  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(loadBrands())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded])

  const brand = brands.find((b) => b.k === brandKey)

  const back = (
    <Link to="/discs/brands" className="discs-back">
      ← Back to brands
    </Link>
  )

  if (!brand) {
    return (
      <div className="brand-details">
        {back}
        <p className="discs-empty">
          {loading ? 'Loading brand…' : 'Brand not found.'}
        </p>
      </div>
    )
  }

  const molds = [...(brand.di || [])].sort((a, b) => a.nm.localeCompare(b.nm))
  const plastics = brand.pl || []

  return (
    <div className="brand-details">
      {back}
      <h2>{brand.nm}</h2>

      <h3>Discs</h3>
      {molds.length === 0 ? (
        <p className="discs-empty">No discs listed for this brand.</p>
      ) : (
        <Table hover className="discs-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Flight</th>
            </tr>
          </thead>
          <tbody>
            {molds.map((mold) => (
              <tr key={mold.nm} className="discs-table-row">
                <td className="discs-table-col discs-table-col-name">
                  {mold.nm}
                </td>
                <td className="discs-table-col discs-table-col-type">
                  {discTypeName(mold.to)}
                </td>
                <td className="discs-table-col discs-table-col-flight">
                  <FlightNumbers disc={mold} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {plastics.length > 0 && (
        <>
          <h3>Plastics</h3>
          <ul className="brand-plastics">
            {plastics.map((plastic) => (
              <li key={plastic.nm}>
                <b>{plastic.nm}</b>
                {plastic.d ? ` — ${plastic.d}` : ''}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  brands: state.brands.data,
  loading: state.brands.loading,
  loaded: state.brands.loaded,
})

export default connect(mapStateToProps)(BrandDetails)
